<script setup>
  import Layout from "@/layouts/main.vue";
  import PageHeader from "@/components/page-header";
  import '@jobinsjp/vue3-datatable/dist/style.css';
  import { DataTable, TableBody, TableHead, TableBodyCell } from '@jobinsjp/vue3-datatable';
  import moment from 'moment';
  import { truncate } from 'lodash';
  import Swal from 'sweetalert2';

  import { computed, ref } from 'vue';
  import { useStore } from 'vuex';

  const store = useStore();
  const loading = computed(() => store.state.globals.loading);
  const violationTypes = computed(() => store.state.cameraViolation.violationTypes);
  const pagination = computed(() => store.state.cameraViolation.pagination);
  const title = ref("Camera Captured Violation");
  const items = ref([
    {
      text: "Home",
      href: "/"
    },
    {
      text: "Settings",
    },
    {
      text: "Camera Captured Violation",
      active: true,
    }
  ])

  const query = ref({
    search: ''        
  })

  const getAllViolationTypes = async (dt) => {
    await store.dispatch('cameraViolation/getViolationTypes', {
      page: dt.page,
      pageSize: dt.per_page ,
      sortColumn: 'updated_at',
      search: dt.search,
      orderBy: 'desc'
    });
  }

  const formattedDate = (date) => {
    return moment(date).format('YYYY-MM-DD h:mm A')
  }

  const deleteViolationType = (id, name) => {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Delete",
      }).then((result) => {
        if (result.value) {
          store.dispatch('cameraViolation/deleteViolationType', id);
          Swal.fire("Deleted!", `Violation type ${name} has been successfully deleted!`, "success");
        }
      });
  }
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-overlay :show="loading">
        <div class="d-flex mb-4 justify-content-between">
          <div>
            <h1 class="fs-4 text">Camera Captured Violation & Violation Tagging</h1>
            <small>Tag violations based from Camera Captured</small>
          </div>
          <div>
             <router-link
                  to="/settings/camera/violation/create"
                  class="btn btn-primary right"
                >
                 <i class="ri-add-fill label-icon align-middle fs-16 me-2"></i>
                  New Violation Tagging
              </router-link>
          </div>
        </div>

        <div class="row">
          <div class="col lg-12">
              <data-table
                  :rows="violationTypes"
                  :pagination="pagination"
                  striped
                  :loading="loading"
                  :query="query"
                  filter
                  hoverable
                  sortable
                  @loadData="getAllViolationTypes"
                >

                <template #thead>
                    <table-head>LGU</table-head>
                    <table-head>Camera Violation</table-head>
                    <table-head>Violation Tagged</table-head>
                    <table-head>Date Modified</table-head>
                    <table-head>Actions</table-head>
                </template>

                <template #tbody="{row}">
                    <table-body v-text="truncate(row.lgu?.name)" />
                    <table-body v-text="truncate(row.violation, { length: 30 })" :title="row.violation" />
                    <table-body v-text="truncate(row.violation_candidates ? row.violation_candidates?.[0]?.violation?.name : 'N/A', { length: 35 })" :title="row.article" />
                    <table-body v-text="formattedDate(row.updated_at)" />
                    <table-body>
                      <router-link
                          :to="`/settings/camera/violation/${row.id}/edit`"
                          class="btn btn-info mr-3"
                          title="Edit"
                        >
                        <i class="ri-pencil-line label-icon align-middle"></i>
                      </router-link>
                      <button class="btn btn-danger" type="button" title="Delete" @click.prevent="deleteViolationType(row.id, row.violation)">
                        <i class="mdi mdi-delete label-icon align-middle"></i>
                      </button>
                    </table-body>
                </template>

                <template #empty>
                  <TableBodyCell colspan="10">
                      No Violation Types found.
                  </TableBodyCell>
              </template>
            </data-table>
          </div>
        </div>
      </b-overlay>
  </Layout>
</template>